<template>
    <div class="reservation">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="hidden-print">
                <div class="page-header">
                    <h1>
                        {{reservation.name}}
                    </h1>
                </div>

                <div class="row">
                    <div class="col-lg-8 col-md-7 col-sm-6">
                        <invoice :id="reservation.id"></invoice>
                    </div>

                    <div class="col-lg-4 col-md-5 col-sm-6">
                        <card>
                            <div class="text-center">
                                <strong>Reservation</strong>
                            </div>

                            <hr />

                            <form class="form-horizontal">
                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Name</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="reservation.name">
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Type</label>
                                    <div class="col-sm-8">
                                        <multiselect placeholder="Type" v-model="selectedType" track-by="label" label="label" :options="typeOptions" :close-on-select="true" :show-labels="false"></multiselect>
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Room</label>
                                    <div class="col-sm-8">
                                        <multiselect placeholder="Room" v-model="selectedRoom" track-by="label" label="label" :options="roomOptions" :close-on-select="true" :show-labels="false"></multiselect>
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Comment</label>
                                    <div class="col-sm-8">
                                        <textarea class="form-control" v-model="reservation.comment"></textarea>
                                    </div>
                                </div>

                                <br />

                                <div class="form-group" :class="{'has-error': doubleBooking}">
                                    <label class="col-sm-4 control-label">Arrival</label>
                                    <div class="col-sm-8">
                                        <date-picker v-model="reservation.arrival.date" :config="{format: 'YYYY-MM-DD'}"></date-picker>
                                    </div>
                                </div>

                                <br />

                                <div class="form-group" :class="{'has-error': doubleBooking}">
                                    <label class="col-sm-4 control-label">Departure</label>
                                    <div class="col-sm-8">
                                        <date-picker v-model="reservation.departure.date" :config="{format: 'YYYY-MM-DD'}"></date-picker>
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Number of guests</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="reservation.guests">
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <label class="col-sm-4 control-label">Breakfast</label>
                                    <div class="col-sm-4">
                                        <small>Eating guests</small>
                                        <input type="text" class="form-control" v-model="reservation.numberOfBreakfasts">
                                    </div>
                                    <div class="col-sm-4">
                                        <small>Total for all nights</small>
                                        <input type="text" class="form-control" v-model="reservation.totalPriceBreakfast">
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <div class="col-sm-offset-4 col-sm-8">
                                        <button type="submit" class="btn btn-primary" @click="update">Update reservation</button>
                                    </div>
                                </div>
                            </form>
                        </card>

                        <card>
                            <div class="text-center">
                                <strong>Invoice</strong>
                            </div>

                            <hr />

                            <form class="form-horizontal">
                                <button type="button" class="btn btn-primary" @click="print">Print</button>

                                <!--
                                <div class="form-group">
                                    <label class="col-sm-4 control-label">E-mail</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="email" class="form-control">
                                    </div>
                                </div>

                                <br />

                                <div class="form-group">
                                    <div class="col-sm-offset-4 col-sm-8">
                                        <button type="submit" class="btn btn-primary">Send invoice</button>
                                        &nbsp; or &nbsp;
                                        <button type="button" class="btn btn-primary" @click="print">Print</button>
                                    </div>
                                </div>
                                -->
                            </form>
                        </card>

                        <card>
                            <div class="text-center">
                                <strong>Products</strong>
                            </div>

                            <hr />

                            <products :id="reservation.id"></products>
                        </card>

                        <card>
                            <div class="text-center">
                                <strong>Delete reservation</strong>
                            </div>

                            <hr />

                            <div class="text-center">
                                <button type="button" class="btn btn-danger" @click="remove">Delete this reservation</button>
                            </div>
                        </card>
                    </div>
                </div>
            </div>

            <div class="visible-print">
                <invoice :id="reservation.id"></invoice>
            </div>
        </template>
    </div>
</template>

<script>
    import Card from '@/components/layout/Card'
    import Loader from '@/components/layout/Loader'
    import Invoice from '@/components/reservations/Invoice'
    import Products from '@/components/reservations/Products'
    import Multiselect from 'vue-multiselect'

    import DatePicker from 'vue-bootstrap-datetimepicker'

    const ReservationService = require('@/services/reservations/ReservationService')
    const TypeService = require('@/services/reservations/TypeService')
    const RoomService = require('@/services/rooms/RoomService')

    const moment = require('moment')

    export default {
        data() {
            return {
                reservation: null,
                room: null,
                hasLoaded: false,
                doubleBooking: false,

                types: [],
                selectedType: null,

                rooms: [],
                selectedRoom: null,
            }
        },

        watch: {
            selectedType() {
                this.$set(this.reservation, 'type', this.selectedType.value)
            },

            types() {
                if (!this.reservation) {
                    return
                }

                this.matchType()
            },

            selectedRoom() {
                this.$set(this.reservation, 'room', this.selectedRoom.value)
            },

            rooms() {
                if (!this.reservation) {
                    return
                }

                this.matchRoom()
            },

            reservation() {
                if (!this.types.length) {
                    return
                }

                this.matchType()
            }
        },

        computed: {
            typeOptions() {
                return this.types.map((type) => {
                    return {
                        label: type.title,
                        value: type.id
                    }
                })
            },

            roomOptions() {
                return this.rooms.map((room) => {
                    return {
                        label: room.title,
                        value: room.id
                    }
                })
            },
        },

        mounted() {
            this.load()
            this.loadTypes()
            this.loadRooms()
        },

        methods: {
            load() {
                const options = {
                    includes: ['room', 'type']
                }

                ReservationService.find(this.$route.params.id, options, (response) => {
                    const data = response.data

                    this.reservation = data
                    this.hasLoaded = true
                })
            },

            update() {
                this.hasLoaded = false
                this.doubleBooking = false

                let options = JSON.parse(JSON.stringify(this.reservation))

                options.arrival = moment(options.arrival.date).format('YYYY-MM-DD')
                options.departure = moment(options.departure.date).format('YYYY-MM-DD')

                ReservationService.update(this.$route.params.id, options, (response) => {
                    this.hasLoaded = true
                }, (response) => {
                    this.hasLoaded = true
                    this.doubleBooking = true
                })
            },

            print() {
                window.print()
            },

            remove() {
                this.$swal({
                    type: 'warning',
                    title: 'Are you sure?',
                    description: 'This action is permanent',
                    showCancelButton: true
                }).then(() => {
                    ReservationService.remove(this.reservation.id)

                    this.$swal(
                        'Success',
                        'The reservation has been deleted',
                        'success'
                    )

                    setTimeout(() => {
                        this.$router.push({
                            name: 'reservations'
                        })
                    }, 600)
                })
            },

            loadTypes() {
                TypeService.findAll({}, (response) => {
                    this.types = response.data.rows
                    this.hasLoaded = true
                })
            },

            matchType() {
                if (!this.reservation.type) {
                    return
                }

                const types = this.typeOptions.filter((type) => {
                    return type.value === this.reservation.type.id
                })

                if (!types.length) {
                    return
                }

                this.selectedType = types[0]
            },

            loadRooms() {
                RoomService.findAll({}, (response) => {
                    this.rooms = response.data.rows
                    this.hasLoaded = true
                })
            },

            matchRoom() {
                if (!this.reservation.room) {
                    return
                }

                const rooms = this.roomOptions.filter((room) => {
                    return room.value === this.reservation.room.id
                })

                if (!rooms.length) {
                    return
                }

                this.selectedRoom = rooms[0]
            }
        },

        components: {
            Card,
            Loader,
            Invoice,
            Products,
            DatePicker,
            Multiselect
        }
    }
</script>


// WEBPACK FOOTER //
// View.vue?72dba5f5